export default __webpack_public_path__ + "static/media/developers-for-social-media-app.683c1946.png";